import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getPayoutMethodRequirementName } from "../helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayerStatusCell } from "../helpers/getPayoutMethodRequirementPayerStatusCell";

export const usePayerPayoutMethodConfig = (
  _: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  InsuranceCoverageMonitor | undefined
> => {
  return {
    isActionRequired: () => false,

    requirementName: getPayoutMethodRequirementName,

    toolbarActions: () => [],

    nameCell: requirement => ({
      text: getPayoutMethodRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getPayoutMethodRequirementPayerStatusCell
  };
};
